export default "__VITE_ASSET__e3woGYl2__"